// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'

require('./filter.js');

Vue.prototype.wx = wx
Vue.prototype.contentFilters = function (msg) {
  return msg.replace(/\n/ig, '<br />')
}

Vue.use(VueAxios, axios);

var qs = require('qs');

// 微信配置
// AjaxWxConfig
Vue.axios.post(
  '/index.php?r=web/ajaxwxconfig&v=4.2.0',
  qs.stringify({}),
  {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  }
).then(res => {
  let resBody = res.data;
  if (resBody.appId) {
    wx.config({
      debug: false,
      appId: resBody.appId,
      timestamp: resBody.timestamp,
      nonceStr: resBody.nonceStr,
      signature: resBody.signature,
      jsApiList: resBody.jsApiList
    });
  }

});

// window.setShareConfig = (opt) => {
//   console.info(opt)
//   wx.onMenuShareTimeline({
//     title: opt.title, // 分享标题
//     link: opt.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//     imgUrl: opt.imgUrl // 分享图标
//   });
//   wx.onMenuShareAppMessage({
//     title: opt.title, // 分享标题
//     desc: opt.desc, // 分享描述
//     link: opt.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
//     imgUrl: opt.imgUrl // 分享图标
//   });
// }

// 判断登录
window.globalData = {
  isLogin: /Xz_auth/.test(document.cookie)
};

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,

  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js